import './Staff.css';
import React, { useReducer, useMemo, useState, useEffect, useCallback } from "react";
import { Dropdown, Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { ToastContainer } from "react-toastify";
import Cropper from 'react-easy-crop'
import CustomButton from '../../Components/Reusable/Button/CustomButton';
import ColorPickerField from '../../Components/ColourPicker/ColourPicker';
import BackButton from '../../Components/Reusable/BackButton/BackButton';
import { FaPlusCircle } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import MyAlert from "../../Components/Reusable/Alert/Alert"
import { DateTime } from "luxon"
import { usePagination } from "../../Components/Reusable/TablePagination/Functions";
import TablePaginationFooter from "../../Components/Reusable/TablePagination/TableFooter";
import {
  GetServices,
  AddBarber,
  GetBarbers,
  GetBarberWorkingTimes,
  EditBarber,
  DeleteBarber,
  ActivateBarber,
  DisableBarber,
  GetFutureAppointmentsByBarber,
  getCroppedImg,
  GetConfig
} from '../Services/Requests';
import {
  notifySuccess,
  notifyError
} from '../../Response/ResposeHandler'
import { useTranslation } from "react-i18next";

const ManageStaff = () => {
  const { t } = useTranslation('staff');

  const [times, setTimes] = useState()
  const [sundayCheck, setSundayCheck] = useState(false)
  const [mondayCheck, setMondayCheck] = useState(false)
  const [tuesdayCheck, setTuesdayCheck] = useState(false)
  const [wednesdayCheck, setWednesdayCheck] = useState(false)
  const [thursdayCheck, setThursdayCheck] = useState(false)
  const [fridayCheck, setFridayCheck] = useState(false)
  const [saturdayCheck, setSaturdayCheck] = useState(false)
  const [sundayStartHours, setSundayStartHours] = useState()
  const [sundayEndHours, setSundayEndHours] = useState()
  const [mondayStartHours, setMondayStartHours] = useState()
  const [mondayEndHours, setMondayEndHours] = useState()
  const [tuesdayStartHours, setTuesdayStartHours] = useState()
  const [tuesdayEndHours, setTuesdayEndHours] = useState()
  const [wednesdayStartHours, setWednesdayStartHours] = useState()
  const [wednesdayEndHours, setWednesdayEndHours] = useState()
  const [thursdayStartHours, setThursdayStartHours] = useState()
  const [thursdayEndHours, setThursdayEndHours] = useState()
  const [fridayStartHours, setFridayStartHours] = useState()
  const [fridayEndHours, setFridayEndHours] = useState()
  const [saturdayStartHours, setSaturdayStartHours] = useState()
  const [saturdayEndHours, setSaturdayEndHours] = useState()
  const [services, setServices] = useState([])
  const [barberName, setBarberName] = useState('')
  const [barberServices, setBarberServices] = useState([])
  const [barberRawData, setBarberRawData] = useState(null);
  const [barberData, setBarberData] = useState(null);
  const [isAddBarberButtonLoading, setIsAddBarberButtonLoading] = useState(false)
  const [isActivateBarberButtonLoading, setIsActivateBarberButtonLoading] = useState(false)
  const [isDisableBarberButtonLoading, setIsDisableBarberButtonLoading] = useState(false)
  const [isDeleteBarberButtonLoading, setIsDeleteBarberButtonLoading] = useState(false)
  const [barberColour, setBarberColour] = useState("#84b3adff")
  const [isEdit, setIsEdit] = useState(false)
  const [barberId, setBarberId] = useState(null)
  const [imgBust, setImgBust] = useState(0);
  const [config, setConfig] = useState()

  let errorsObj = {
    barberName: '',
    barberServices: '',
    BarberImage: '',
    BarberHours: '',
    sundayErrors: '',
    mondayErrors: '',
    tuesdayErrors: '',
    wednesdayErrors: '',
    thursdayErrors: '',
    fridayErrors: '',
    saturdayErrors: ''
  };
  const [errors, setErrors] = useState(errorsObj);
  const [barberImage, setBarberImage] = useState("data:image/jpeg;base64," + null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const initialState = false;
  const reducer = (state, action) => {
    switch (action.type) {
      case 'addBarberOpen':
        return { ...state, addBarber: true }
      case 'addBarberClose':
        return { ...state, addBarber: false }
      case 'addSetHoursOpen':
        return { ...state, setBarberHours: true }
      case 'addSetHoursClose':
        return { ...state, setBarberHours: false }
      case 'cropImageOpen':
        return { ...state, cropImage: true }
      case 'cropImageClose':
        return { ...state, cropImage: false }
      default:
        return state
    }
  }

  useEffect(() => {
    GetBarberWorkingTimesWrapper()
    GetBarbersWrapper()
    GetServicesWrapper()
    GetConfigWrapper()
    // eslint-disable-next-line
  }, []);

  const total = barberData?.length ?? 0;
  const { page, setPage, pageSize, setPageSize, start, end, canPrev, canNext } =
    usePagination(total);
  const paged = useMemo(() => (barberData ? barberData.slice(start, end) : []), [barberData, start, end]);

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "#525252" : "#7e7e7e",
  });

  const ClearIndicator = (props) => {
    const {
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{t('select.clear')}</div>
      </div>
    );
  };

  const floatingMenuProps = {
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    menuPosition: 'fixed',
    menuPlacement: 'auto',
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menu: (base) => ({ ...base, zIndex: 9999 }),
    },
  };

  const resetFields = () => {
    setBarberColour("#84b3adff")
    setSundayCheck(false);
    setMondayCheck(false);
    setTuesdayCheck(false);
    setWednesdayCheck(false);
    setThursdayCheck(false);
    setFridayCheck(false);
    setSaturdayCheck(false);
    setBarberName('');
    setBarberServices('');
    setSundayStartHours();
    setSundayEndHours();
    setMondayStartHours();
    setMondayEndHours();
    setTuesdayStartHours();
    setTuesdayEndHours();
    setWednesdayStartHours();
    setWednesdayEndHours();
    setThursdayStartHours();
    setThursdayEndHours();
    setFridayStartHours();
    setFridayEndHours();
    setSaturdayStartHours();
    setSaturdayEndHours();
    setErrors(errorsObj);
    setIsAddBarberButtonLoading(false);
    setBarberImage("data:image/jpeg;base64," + null)
  }

  function onSetWorkingHoursClick(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (barberName === '') {
      errorObj.barberName = t('form.errors.nameRequired');
      error = true;
    }
    if (barberServices.length === 0 || barberServices === null || barberServices === undefined) {
      errorObj.barberServices = t('form.errors.servicesRequired');
      error = true;
    }

    if (!barberImage || barberImage === "data:image/jpeg;base64,null") {
      errorObj.barberImage = t('form.errors.imageRequired');
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    dispatch({ type: 'addBarberClose' });
    dispatch({ type: 'addSetHoursOpen' });
  }

  function GetServicesWrapper() {
    GetServices().then((res) => {
      var tempVar = []
      // eslint-disable-next-line
      res.data.map((item, index) => {
        var obj = { value: item.serviceId, label: item.name, isDisabled: item.status === 1 ? false : true }
        tempVar.push(obj)
      })
      setServices(tempVar)
    }).catch(() => {
      notifyError(t('toasts.servicesLoadError'))
    })
  }

  function GetBarbersWrapper() {
    setBarberData(null)
    GetBarbers().then((res) => {
      var data = []
      res.data.forEach(element => {
        var returnData = createData(
          element.barberId,
          element.name,
          element.filename,
          element.imageFile,
          element.serviceNames,
          element.status,
          element.sunday,
          element.monday,
          element.tuesday,
          element.wednesday,
          element.thursday,
          element.friday,
          element.saturday,
          element.barberColour
        )
        data.push(returnData)
      });
      setBarberData(data)
      setBarberRawData(res.data);
    }).catch(() => {
      notifyError(t('toasts.barbersLoadError'))
    })
  }

  function GetBarberWorkingTimesWrapper() {
    GetBarberWorkingTimes().then((res) => {
      setTimes(res.data)
    }).catch(() => {
      notifyError(t('toasts.workingTimesLoadError'))
    })
  }

  function OnDeleteService(barberId) {
    setIsDeleteBarberButtonLoading(true)
    GetFutureAppointmentsByBarber(barberId).then((res) => {
      if (res.data.length > 0) {
        MyAlert.fire({
          icon: 'error',
          title: t('alerts.hasFuture'),
          html: `${t('alerts.handleBeforeDelete')} <b>`
            + res.data.map((appointment) => {
              return '<br/>' +
                appointment.firstName +
                " " +
                appointment.lastName +
                '&nbsp &nbsp' +
                new Date(DateTime.fromISO(appointment.startDateTime, { zone: "utc" }).setZone(config.timeZone).toString().split("+")[0]).toLocaleDateString() +
                " @ " +
                new Date(DateTime.fromISO(appointment.startDateTime, { zone: "utc" }).setZone(config.timeZone).toString().split("+")[0]).toLocaleTimeString() +
                " - " +
                new Date(DateTime.fromISO(appointment.endDateTime, { zone: "utc" }).setZone(config.timeZone).toString().split("+")[0]).toLocaleTimeString()
            })
        })
        setIsDeleteBarberButtonLoading(false)
      } else {
        MyAlert.fire({
          title: t('alerts.confirmDeleteTitle'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'var(--primary)',
          cancelButtonColor: '#aaa',
          confirmButtonText: t('alerts.confirm')
        }).then((result) => {
          if (result.isConfirmed) {
            DeleteBarber(barberId).then(() => {
              notifySuccess(t('toasts.barberDeleted'))
              GetBarbersWrapper()
            }).catch(() => {
              notifyError(t('toasts.barberDeleteError'))
            }).finally(() => {
              setIsDeleteBarberButtonLoading(false)
            })
          }
          else
          {
            setIsDeleteBarberButtonLoading(false)
          }
        })
      }
    })
  }

  function OnEditBarber(barberId) {
    resetFields()
    setIsEdit(true)
    setBarberId(barberId)
    setErrors(errorsObj);
    const barberToEdit = barberRawData.filter(item => item.barberId === barberId)[0];
    setBarberImage("data:image/jpeg;base64," + barberToEdit.imageFile)
    if (barberToEdit.serviceIds.length === 0) {
      setBarberServices('');
    } else {
      var serv = [];
      barberToEdit.serviceIds.forEach(s => { serv.push(s) })
      var servicesToSelect = services.filter(item => serv.includes(item.value))
      setBarberServices(servicesToSelect)
    }
    setBarberColour(barberToEdit.barberColour)
    setBarberName(barberToEdit.name)

    if (barberToEdit.sunday.start !== null) {
      setSundayCheck(true)
      var sundayStartTimeToSelect = times.filter(item => item.label === barberToEdit.sunday.start)[0]
      var sundayEndTimeToSelect = times.filter(item => item.label === barberToEdit.sunday.end)[0]
      setSundayStartHours(sundayStartTimeToSelect);
      setSundayEndHours(sundayEndTimeToSelect);
    }
    if (barberToEdit.monday.start !== null) {
      setMondayCheck(true)
      var mondayStartTimeToSelect = times.filter(item => item.label === barberToEdit.monday.start)[0]
      var mondayEndTimeToSelect = times.filter(item => item.label === barberToEdit.monday.end)[0]
      setMondayStartHours(mondayStartTimeToSelect);
      setMondayEndHours(mondayEndTimeToSelect);
    }
    if (barberToEdit.tuesday.start !== null) {
      setTuesdayCheck(true)
      var tuesdayStartTimeToSelect = times.filter(item => item.label === barberToEdit.tuesday.start)[0]
      var tuesdayEndTimeToSelect = times.filter(item => item.label === barberToEdit.tuesday.end)[0]
      setTuesdayStartHours(tuesdayStartTimeToSelect);
      setTuesdayEndHours(tuesdayEndTimeToSelect);
    }
    if (barberToEdit.wednesday.start !== null) {
      setWednesdayCheck(true)
      var wednesdayStartTimeToSelect = times.filter(item => item.label === barberToEdit.wednesday.start)[0]
      var wednesdayEndTimeToSelect = times.filter(item => item.label === barberToEdit.wednesday.end)[0]
      setWednesdayStartHours(wednesdayStartTimeToSelect);
      setWednesdayEndHours(wednesdayEndTimeToSelect);
    }
    if (barberToEdit.thursday.start !== null) {
      setThursdayCheck(true)
      var thursdayStartTimeToSelect = times.filter(item => item.label === barberToEdit.thursday.start)[0]
      var thursdayEndTimeToSelect = times.filter(item => item.label === barberToEdit.thursday.end)[0]
      setThursdayStartHours(thursdayStartTimeToSelect);
      setThursdayEndHours(thursdayEndTimeToSelect);
    }
    if (barberToEdit.friday.start !== null) {
      setFridayCheck(true)
      var fridayStartTimeToSelect = times.filter(item => item.label === barberToEdit.friday.start)[0]
      var fridayEndTimeToSelect = times.filter(item => item.label === barberToEdit.friday.end)[0]
      setFridayStartHours(fridayStartTimeToSelect);
      setFridayEndHours(fridayEndTimeToSelect);
    }
    if (barberToEdit.saturday.start !== null) {
      setSaturdayCheck(true)
      var saturdayStartTimeToSelect = times.filter(item => item.label === barberToEdit.saturday.start)[0]
      var saturdayEndTimeToSelect = times.filter(item => item.label === barberToEdit.saturday.end)[0]
      setSaturdayStartHours(saturdayStartTimeToSelect);
      setSaturdayEndHours(saturdayEndTimeToSelect);
    }
    dispatch({ type: 'addBarberOpen' });
  }

  function OnSubmitClick(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (sundayCheck) {
      if (sundayStartHours == null || sundayEndHours == null) {
        errorObj.sundayErrors = t('form.errors.required');
        error = true;
      } else if (sundayStartHours.value >= sundayEndHours.value) {
        errorObj.sundayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }
    if (mondayCheck) {
      if (mondayStartHours == null || mondayEndHours == null) {
        errorObj.mondayErrors = t('form.errors.required');
        error = true;
      } else if (mondayStartHours.value >= mondayEndHours.value) {
        errorObj.mondayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }
    if (tuesdayCheck) {
      if (tuesdayStartHours == null || tuesdayEndHours == null) {
        errorObj.tuesdayErrors = t('form.errors.required');
        error = true;
      } else if (tuesdayStartHours.value >= tuesdayEndHours.value) {
        errorObj.tuesdayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }
    if (wednesdayCheck) {
      if (wednesdayStartHours == null || wednesdayEndHours == null) {
        errorObj.wednesdayErrors = t('form.errors.required');
        error = true;
      } else if (wednesdayStartHours.value >= wednesdayEndHours.value) {
        errorObj.wednesdayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }
    if (thursdayCheck) {
      if (thursdayStartHours == null || thursdayEndHours == null) {
        errorObj.thursdayErrors = t('form.errors.required');
        error = true;
      } else if (thursdayStartHours.value >= thursdayEndHours.value) {
        errorObj.thursdayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }
    if (fridayCheck) {
      if (fridayStartHours == null || fridayEndHours == null) {
        errorObj.fridayErrors = t('form.errors.required');
        error = true;
      } else if (fridayStartHours.value >= fridayEndHours.value) {
        errorObj.fridayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }
    if (saturdayCheck) {
      if (saturdayStartHours == null || saturdayEndHours == null) {
        errorObj.saturdayErrors = t('form.errors.required');
        error = true;
      } else if (saturdayStartHours.value >= saturdayEndHours.value) {
        errorObj.saturdayErrors = t('form.errors.invalidStartTime');
        error = true;
      }
    }

    setErrors(errorObj);
    if (error) return;
    setIsAddBarberButtonLoading(true)

    var serviceIds = []
    barberServices.forEach((item) => {
      serviceIds.push(item.value)
    })

    var sundayStartHoursVar = sundayCheck ? sundayStartHours.value : -1
    var sundayEndHoursVar = sundayCheck ? sundayEndHours.value : 0
    var mondayStartHoursVar = mondayCheck ? mondayStartHours.value : -1
    var mondayEndHoursVar = mondayCheck ? mondayEndHours.value : 0
    var tuesdayStartHoursVar = tuesdayCheck ? tuesdayStartHours.value : -1
    var tuesdayEndHoursVar = tuesdayCheck ? tuesdayEndHours.value : 0
    var wednesdayStartHoursVar = wednesdayCheck ? wednesdayStartHours.value : -1
    var wednesdayEndHoursVar = wednesdayCheck ? wednesdayEndHours.value : 0
    var thursdayStartHoursVar = thursdayCheck ? thursdayStartHours.value : -1
    var thursdayEndHoursVar = thursdayCheck ? thursdayEndHours.value : 0
    var fridayStartHoursVar = fridayCheck ? fridayStartHours.value : -1
    var fridayEndHoursVar = fridayCheck ? fridayEndHours.value : 0
    var saturdayStartHoursVar = saturdayCheck ? saturdayStartHours.value : -1
    var saturdayEndHoursVar = saturdayCheck ? saturdayEndHours.value : 0

    var barberImageFile = base64ToFile(barberImage, "barberImage.jpg")

    if (!isEdit) {
      AddBarber(
        barberName,
        serviceIds,
        barberImage === "data:image/jpeg;base64,null" ? null : barberImageFile,
        sundayStartHoursVar,
        sundayEndHoursVar,
        mondayStartHoursVar,
        mondayEndHoursVar,
        tuesdayStartHoursVar,
        tuesdayEndHoursVar,
        wednesdayStartHoursVar,
        wednesdayEndHoursVar,
        thursdayStartHoursVar,
        thursdayEndHoursVar,
        fridayStartHoursVar,
        fridayEndHoursVar,
        saturdayStartHoursVar,
        saturdayEndHoursVar,
        barberColour
      ).then(() => {
        notifySuccess(t('toasts.barberAdded'))
        dispatch({ type: 'addSetHoursClose' })
      }).catch((err) => {
      if (err.response.data === "Staff limit reached")
        {
            MyAlert.fire({
              title: t('alerts.staffLimit.title'),
              text: t('alerts.staffLimit.text'),
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: 'var(--primary)',
              cancelButtonColor: '#aaa',
              confirmButtonText: t('alerts.staffLimit.confirmButton')
            }).then((result) => {
              dispatch({ type: 'addSetHoursClose' })
            })
        }
        notifyError(t('toasts.barberAddError'))
      }).finally(() => {
        setIsAddBarberButtonLoading(false)
        GetBarbersWrapper()
      })
    } else {
      EditBarber(
        barberId,
        barberName,
        serviceIds,
        barberImage === "data:image/jpeg;base64,null" ? null : barberImageFile,
        sundayStartHoursVar,
        sundayEndHoursVar,
        mondayStartHoursVar,
        mondayEndHoursVar,
        tuesdayStartHoursVar,
        tuesdayEndHoursVar,
        wednesdayStartHoursVar,
        wednesdayEndHoursVar,
        thursdayStartHoursVar,
        thursdayEndHoursVar,
        fridayStartHoursVar,
        fridayEndHoursVar,
        saturdayStartHoursVar,
        saturdayEndHoursVar,
        barberColour
      ).then(() => {
        notifySuccess(t('toasts.barberEdited'))
        dispatch({ type: 'addSetHoursClose' })
        setImgBust((v) => v + 1);
      }).catch(() => {
        notifyError(t('toasts.barberEditError'))
      }).finally(() => {
        setIsAddBarberButtonLoading(false)
        GetBarbersWrapper()
      })
    }
  }

  function GetConfigWrapper() {
    GetConfig().then((res) => {
      setConfig(res.data)
    }).catch(() => {
    }).finally(() => {
    })
  }

  function OnDisableBarber(barberId) {
    setIsDisableBarberButtonLoading(true)
    DisableBarber(barberId).then(() => {
      notifySuccess(t('toasts.barberDisabled'))
      GetBarbersWrapper()
    }).catch(() => {
      notifyError(t('toasts.barberDisableError'))
    }).finally(() => {
      setIsDisableBarberButtonLoading(false)
    })
  }

  function OnActivateBarber(barberId) {
    setIsActivateBarberButtonLoading(true)
    ActivateBarber(barberId).then(() => {
      notifySuccess(t('toasts.barberActivated'))
      GetBarbersWrapper()
    }).catch(() => {
      notifyError(t('toasts.barberActivateError'))
    }).finally(() => {
      setIsActivateBarberButtonLoading(false)
    })
  }

  const handleImageChange = (e, type) => {
    e.preventDefault()
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImageSrc(imageUrl);
    }
  };

  function DeleteServiceImage(e) {
    e.preventDefault();
    setBarberImage("data:image/jpeg;base64," + null)
  }

  function base64ToFile(base64Data, filename) {
    const arr = base64Data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropDone = async (e) => {
    e.preventDefault()
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    setBarberImage(croppedImage);
    setImageSrc(null);
  };

  const handleCropCancel = () => {
    setImageSrc(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  function createData(barberId, name, filename, image, serviceNames, status, sunday, monday, tuesday, wednesday, thursday, friday, saturday, barberColour) {
    var daysArray = [sunday, monday, tuesday, wednesday, thursday, friday, saturday]
    const buildArray = [];
    for (var i = 0; i < daysArray.length; i++) {
      var obj = { day: daysArray[i], serviceNames: { serviceName: serviceNames[i] === undefined ? "" : serviceNames[i].key, status: serviceNames[i] === undefined ? "" : serviceNames[i].value } }
      buildArray.push(obj)
    }
    return {
      barberId,
      name,
      filename,
      image,
      status,
      barberColour,
      history: buildArray,
    };
  }

  return (
    <div className="h-80 staff-wrapper">
      <ToastContainer />

      {barberData === null ?
        <div className="custom-loader-wrapper">
          <div className="custom-loader"></div>
        </div>
        : barberData.length === 0 ?
          <div>
            <div className="mb-3 add-service-button" style={{ display: 'grid', justifyContent: 'end' }}>
              <CustomButton icon={<FaPlusCircle />} className="app-btn--sm" onClick={() => { dispatch({ type: 'addBarberOpen' }); resetFields(); setIsEdit(false) }} label={t('actions.addStaff')} loading={false} />
            </div>
            <div className='sm-dull'>{t('table.noStaff')}</div>
          </div>
          :
          <div>
            <div className="mb-3 add-service-button" style={{ display: 'grid', justifyContent: 'end' }}>
              <CustomButton icon={<FaPlusCircle />} className="app-btn--sm" onClick={() => { dispatch({ type: 'addBarberOpen' }); resetFields(); setIsEdit(false) }} label={t('actions.addStaff')} loading={false} />
            </div>
            <div className="services-container">
              <div className="data-table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr className="btn-reveal-trigger">
                      <th className="ps-2"></th>
                      <th className="align-middle ps-2">{t('table.name')}</th>
                      <th className="align-middle ps-2">{t('table.status')}</th>
                      <th className="no-sort text-end">{t('table.action')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {barberData === null ? <></> : paged.map((staff) => (
                      <tr key={staff.barberId} className="btn-reveal-trigger">
                        <td>
                          <img
                            className="rounded-circle img-fluid staff-table-image"
                            width="60"
                            alt=""
                            src={`${process.env.REACT_APP_API_SERVICE_BASE_URL}image/BarberProfileImages/${staff.filename}?v=${imgBust}`} />
                        </td>
                        <td>

                          <span
                            component="th" style={{ backgroundColor: staff.barberColour, color: "#fff" }} className={`badge badge-md`} >
                              {/* {staff.name} */}
                          <span className="table-field-ellipsis" title={staff.name}>
                            {staff.name}
                          </span>
                          </span>
                        </td>
                        <td>
                          <span className={`badge badge-sm light ${staff.status === 1 ? 'badge-success' : 'badge-danger'} `}>
                            {staff.status === 1 ? t('status.active') : t('status.disabled')}
                          </span>
                        </td>
                        <td className="py-2 text-end">
                          <Dropdown autoClose={true} className="dropdown text-sans-serif">
                            <Dropdown.Toggle
                              variant=""
                              className="btn tp-btn-light sharp i-false"
                              type="button"
                              id="order-dropdown-0"
                              aria-haspopup="true"
                              aria-expanded="false"
                              drop="up"
                            >
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                    <rect y={0} width={24} height={24} />
                                    <circle fill="#000000" cx={5} cy={12} r={2} />
                                    <circle fill="#000000" cx={12} cy={12} r={2} />
                                    <circle fill="#000000" cx={19} cy={12} r={2} />
                                  </g>
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              renderOnMount
                              popperConfig={{
                                strategy: 'fixed',
                                modifiers: [
                                  { name: 'computeStyles', options: { adaptive: false } },
                                  { name: 'preventOverflow', options: { boundary: 'viewport' } },
                                  { name: 'flip', options: { fallbackPlacements: ['top', 'bottom'] } },
                                ],
                              }}
                              className="dropdown-menu dropdown-menu-right border py-0"
                              aria-labelledby="order-dropdown-0"
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            >
                              {staff.status === 1 ?
                                (isDisableBarberButtonLoading
                                  ? <span style={{ marginLeft: '1rem' }} className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                  : <Dropdown.Item onClick={() => { OnDisableBarber(staff.barberId) }} className="dropdown-item">{t('actions.disable')}</Dropdown.Item>
                                )
                                :
                                (isActivateBarberButtonLoading
                                  ? <span style={{ marginLeft: '1rem' }} className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                  : <Dropdown.Item onClick={() => { OnActivateBarber(staff.barberId) }} className="dropdown-item">{t('actions.activate')}</Dropdown.Item>
                                )
                              }

                              <Dropdown.Item className="dropdown-item" onClick={() => { OnEditBarber(staff.barberId); }} >{t('actions.edit')}</Dropdown.Item>
                              {isDeleteBarberButtonLoading
                                ? <span style={{ marginLeft: '1rem' }} className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                : <Dropdown.Item onClick={() => { OnDeleteService(staff.barberId); }} className="dropdown-item text-danger">{t('actions.delete')}</Dropdown.Item>}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {barberData.length > 8 ?
              <TablePaginationFooter
                total={total}
                page={page}
                pageSize={pageSize}
                setPage={setPage}
                setPageSize={setPageSize}
                canPrev={canPrev}
                canNext={canNext}
              /> : null}
          </div>
      }

      <Modal className="modal fade" show={state.addBarber} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{isEdit ? t('title.edit') : t('title.add')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({ type: 'addBarberClose' })}>
            </Button>
          </div>
          <div className="sm-modal__body">
            <form className="sm-form">
              <div className="sm-grid sm-grid--2">

                <div className={`sm-field sm-grid__full ${errors.barberName ? 'is-error' : ''}`}>
                  <label className="sm-label">
                    {t('form.labels.name')} <span className="sm-req">*</span>
                  </label>
                  <input
                    type="text"
                    className="sm-input"
                    name="serviceName"
                    placeholder={t('form.placeholders.name')}
                    value={barberName}
                    onChange={(e) => setBarberName(e.target.value)}
                  />
                  {errors.barberName && <div className="sm-error">{errors.barberName}</div>}
                </div>

                <div className={`sm-field sm-grid__full ${errors.barberServices ? 'is-error' : ''}`}>
                  <label className="sm-label">
                    {t('form.labels.selectServices')} <span className="sm-req">*</span>
                  </label>
                  <Select
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    components={{ ClearIndicator }}
                    styles={{ clearIndicator: ClearIndicatorStyles }}
                    isMulti
                    style={{ height: 'none' }}
                    defaultValue={barberServices}
                    options={services}
                    onChange={(e) => setBarberServices(e)}
                    className="sm-select"
                    classNamePrefix="rs"
                  />
                  {errors.barberServices && <div className="sm-error">{errors.barberServices}</div>}
                </div>

                <div className="sm-field sm-grid__full">
                  <label className="sm-label">{t('image.label')}</label>

                  <div className="sm-image sm-image--stack">
                    <div className="sm-staff-image__preview">
                      {barberImage !== 'data:image/jpeg;base64,null'
                        ? <img src={barberImage} alt="service" />
                        : <div className="sm-image__placeholder">{t('image.placeholder')}</div>}
                    </div>

                    <div className="sm-image__actions sm-image__actions--stack">
                      <label className="sm-btn sm-btn--primary">
                        {t('actions.uploadProfile')}
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => { handleImageChange(e, 'logo'); e.target.value = null }}
                          hidden
                        />
                      </label>

                      <button type="button" onClick={DeleteServiceImage} className="sm-btn sm-btn--ghost">
                        {t('actions.deleteImage')}
                      </button>
                    </div>
                  </div>
                  {errors.barberImage && <div className="sm-error">{errors.barberImage}</div>}
                </div>

                <div className="col-lg-12">
                  <div>
                    {imageSrc && (
                      <div className="cropper-modal">
                        <div className="cropper-wrapper">
                          <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={400 / 400}
                            cropShape="round"
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                          />
                          <div className="crop-controls">
                            <button className="upload-button" onClick={handleCropDone}>
                              {t('actions.crop')}
                            </button>
                            <button className="upload-button cancel-button" onClick={handleCropCancel}>
                              {t('actions.cancel')}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    <ColorPickerField
                      label={t('form.labels.chooseColour')}
                      value={barberColour}
                      onChange={setBarberColour}
                      closeOnSelect={true}
                      applyOnDrag={true}
                    />
                  </div>
                </div>

                <div className="sm-actions sm-grid__full">
                  <CustomButton className="app-btn--sm" onClick={onSetWorkingHoursClick} label={t('actions.setWorkingHours')} loading={false} />
                </div>

              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal className="modal fade" show={state.setBarberHours} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('modals.setWorkingHours')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({ type: 'addSetHoursClose' })}></Button>
          </div>

          <div className="sm-modal__body">
            <form className="sm-form">
              <div className="hours-list">

                {/* Sunday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="sundayCheck"
                        defaultChecked={sundayCheck}
                        onChange={(e) => { setSundayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.sunday')}</span>
                    </label>
                  </div>

                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!sundayCheck}
                      defaultValue={sundayStartHours}
                      onChange={(e) => { setSundayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!sundayCheck}
                      defaultValue={sundayEndHours}
                      onChange={(e) => { setSundayEndHours({ value: e.value, label: e.label }); }}
                    />
                  </div>
                </div>
                {errors.sundayErrors && <div className="sm-error">{errors.sundayErrors}</div>}

                {/* Monday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="mondayCheck"
                        defaultChecked={mondayCheck}
                        onChange={(e) => { setMondayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.monday')}</span>
                    </label>
                  </div>
                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!mondayCheck}
                      defaultValue={mondayStartHours}
                      onChange={(e) => { setMondayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!mondayCheck}
                      defaultValue={mondayEndHours}
                      onChange={(e) => { setMondayEndHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                  </div>
                </div>
                {errors.mondayErrors && <div className="sm-error">{errors.mondayErrors}</div>}

                {/* Tuesday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="tuesdayCheck"
                        defaultChecked={tuesdayCheck}
                        onChange={(e) => { setTuesdayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.tuesday')}</span>
                    </label>
                  </div>
                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!tuesdayCheck}
                      defaultValue={tuesdayStartHours}
                      onChange={(e) => { setTuesdayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!tuesdayCheck}
                      defaultValue={tuesdayEndHours}
                      onChange={(e) => { setTuesdayEndHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                  </div>
                </div>
                {errors.tuesdayErrors && <div className="sm-error">{errors.tuesdayErrors}</div>}

                {/* Wednesday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="wednesdayCheck"
                        defaultChecked={wednesdayCheck}
                        onChange={(e) => { setWednesdayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.wednesday')}</span>
                    </label>
                  </div>
                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!wednesdayCheck}
                      defaultValue={wednesdayStartHours}
                      onChange={(e) => { setWednesdayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!wednesdayCheck}
                      defaultValue={wednesdayEndHours}
                      onChange={(e) => { setWednesdayEndHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                  </div>
                </div>
                {errors.wednesdayErrors && <div className="sm-error">{errors.wednesdayErrors}</div>}

                {/* Thursday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="thursdayCheck"
                        defaultChecked={thursdayCheck}
                        onChange={(e) => { setThursdayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.thursday')}</span>
                    </label>
                  </div>
                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!thursdayCheck}
                      defaultValue={thursdayStartHours}
                      onChange={(e) => { setThursdayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!thursdayCheck}
                      defaultValue={thursdayEndHours}
                      onChange={(e) => { setThursdayEndHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                  </div>
                </div>
                {errors.thursdayErrors && <div className="sm-error">{errors.thursdayErrors}</div>}

                {/* Friday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="fridayCheck"
                        defaultChecked={fridayCheck}
                        onChange={(e) => { setFridayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.friday')}</span>
                    </label>
                  </div>
                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!fridayCheck}
                      defaultValue={fridayStartHours}
                      onChange={(e) => { setFridayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!fridayCheck}
                      defaultValue={fridayEndHours}
                      onChange={(e) => { setFridayEndHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                  </div>
                </div>
                {errors.fridayErrors && <div className="sm-error">{errors.fridayErrors}</div>}

                {/* Saturday */}
                <div className="day-row">
                  <div className="day-row__left">
                    <label className="day-check">
                      <input
                        type="checkbox"
                        className="day-check__input"
                        id="saturdayCheck"
                        defaultChecked={saturdayCheck}
                        onChange={(e) => { setSaturdayCheck(e.target.checked); }}
                      />
                      <span className="day-check__box" aria-hidden="true" />
                      <span className="day-check__label">{t('days.saturday')}</span>
                    </label>
                  </div>
                  <div className="day-row__right">
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.start')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!saturdayCheck}
                      defaultValue={saturdayStartHours}
                      onChange={(e) => { setSaturdayStartHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                    <Select
                      isSearchable={false}
                      className="sm-select sm-select--grow"
                      classNamePrefix="rs"
                      placeholder={t('form.placeholders.end')}
                      closeMenuOnSelect
                      options={times}
                      isDisabled={!saturdayCheck}
                      defaultValue={saturdayEndHours}
                      onChange={(e) => { setSaturdayEndHours({ value: e.value, label: e.label }); }}
                      {...floatingMenuProps}
                    />
                  </div>
                </div>
                {errors.saturdayErrors && <div className="sm-error">{errors.saturdayErrors}</div>}

              </div>
              <div className="sm-actions">
                <BackButton
                  label={t('actions.back')}
                  icon={<FaArrowLeft />}
                  style={{ marginRight: "auto" }}
                  onClick={() => { dispatch({ type: "addBarberOpen" }); dispatch({ type: "addSetHoursClose" }); }}>
                </BackButton>
                <CustomButton
                  className="app-btn--sm"
                  onClick={OnSubmitClick}
                  loading={isAddBarberButtonLoading}
                  label={isEdit ? t('actions.editStaff') : t('actions.addStaff')}
                />
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ManageStaff;
